<template>
  <div class="mqSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="brokerSummaryIdSearchKey"
          :placeholder="$t('alarms.queue.pleaseEnterBrokerId')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:messageQueueMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableMessageQueue from "../mq/TableMessageQueue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tableMessageQueue = TableMessageQueue;
export default {
  name: "MessageQueueSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      stateSearchKey: [],
      brokerSummaryIdSearchKey: "",
      brokerSummaryIdSearchName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit(
        "brokerSummaryIdSearchName",
        this.brokerSummaryIdSearchKey
      );
      tableMessageQueue.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.mqSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/mq/MessageQueueSearch.vue